import { createAsyncThunk } from "@reduxjs/toolkit";
import doFetch from "../../infrastructure/doFetch";
import { getQueryParams } from "../../helpers";
import { SPINNER_NAMES } from "../../components/organisms/Spinner";

const {
  UPDATE_APPLICATION,
  CREATE_APPLICATION,
  FETCH_APPLICATIONS,
  DELETE_APPLICATION,
  FETCH_APPLICATIONS_DEPLOYMENTS_TRACK,
  FETCH_APPLICATION_BY_ID,
  FETCH_DEPLOY_STATUS,
} = SPINNER_NAMES;

export const createApplication = createAsyncThunk(
  "create-application",
  async (app, args, { useCache, showSpinner } = {}) =>
    doFetch({
      url: "create-template",
      method: "POST",
      config: {
        body: JSON.stringify(app),
      },
      useCache,
      showSpinner,
      spinner: CREATE_APPLICATION,
      errorMessage: "Unable to create app. Please try again later.",
      successMessage: "Successfully created app.",
      ...args,
    })
);

export const fetchApplications = createAsyncThunk(
  "fetch-applications",
  async (filters, args, { useCache, showSpinner } = {}) => {
    const queryParams = filters ? getQueryParams(filters) : "";
    return doFetch({
      url: `applications?${queryParams}`,
      method: "GET",
      useCache,
      showSpinner,
      spinner: FETCH_APPLICATIONS,
      errorMessage:
        "Unable to fetch applications by user id. Please try again later.",
      successMessage: "Successfully fetched applications by user id.",
      ...args,
    });
  }
);

export const fetchApplicationById = createAsyncThunk(
  "fetch-app-by-id",
  async (id, args, { useCache, showSpinner } = {}) =>
    doFetch({
      url: `applications/${id}`,
      method: "GET",
      useCache,
      showSpinner,
      spinner: FETCH_APPLICATION_BY_ID,
      errorMessage:
        "Unable to fetch applications by app id. Please try again later.",
      successMessage: "Successfully fetched applications by app id.",
      ...args,
    })
);

export const updateApplication = createAsyncThunk(
  "update-application",
  async ({ id, app, useCache, showSpinner } = {}, args) =>
    doFetch({
      url: `applications/${id}`,
      method: "PATCH",
      config: {
        body: JSON.stringify(app),
      },
      useCache,
      showSpinner,
      spinner: UPDATE_APPLICATION,
      errorMessage: "Unable to update the app. Please try again later.",
      successMessage: "Successfully updated the app.",
      ...args,
    })
);

export const deleteApplication = createAsyncThunk(
  "delete-application",
  async (id, args, { useCache, showSpinner } = {}) =>
    doFetch({
      url: `applications/${id}`,
      method: "DELETE",
      useCache,
      showSpinner,
      spinner: DELETE_APPLICATION,
      errorMessage: "Unable to delete application. Please try again later.",
      successMessage: "Successfully deleted application.",
      ...args,
    })
);

export const fetchConstantsFromLibrary = createAsyncThunk(
  "fetch-constants",
  async ({ type, useCache, showSpinner } = {}, args) =>
    doFetch({
      url: `library?type=${type}`,
      method: "GET",
      useCache,
      showSpinner,
      errorMessage: "Unable to fetch constants. Please try again later.",
      successMessage: "Successfully fetched constants.",
      ...args,
    })
);

export const fetchApplicationDeploymentStatus = createAsyncThunk(
  "fetch-deploy-status",
  async (filters, args, { useCache, showSpinner } = {}) => {
    const queryParams = filters ? getQueryParams(filters) : "";
    return doFetch({
      url: `deploy-status?${queryParams}`,
      method: "GET",
      useCache,
      showSpinner,
      spinner: FETCH_DEPLOY_STATUS,
      errorMessage: "Unable to fetch pipeline status. Please try again later.",
      successMessage: "Successfully fetched pipeline status.",
      ...args,
    });
  }
);

export const fetchApplicationsDeploymentsTrack = createAsyncThunk(
  "fetch-app-deployments",
  async (id, args, { useCache, showSpinner } = {}) =>
    doFetch({
      url: `deployments-status?applicationId=${id}`,
      method: "GET",
      useCache,
      showSpinner,
      spinner: FETCH_APPLICATIONS_DEPLOYMENTS_TRACK,
      errorMessage:
        "Unable to fetch applications deployments track. Please try again later.",
      successMessage: "Successfully fetched applications deployments track.",
      ...args,
    })
);
